import { z } from 'zod';

import { LosId } from '../../BrandedIds';
import { PaymentStatus } from '../../loan/Payments';
import {
  LoanTransactionDisbursementType,
  TransactionMethod,
  TransactionType,
} from '../../loanTransaction/LoanTransaction';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';
import { zodBrandedString } from '../../utils';

export const ExportableTransaction = z
  .object({
    id: z.string(),
    loanId: zodBrandedString<LosId>(),

    type: TransactionType,
    status: PaymentStatus,
    method: TransactionMethod,
    disbursementType: LoanTransactionDisbursementType,

    amount: z.number(),
    principal: z.number(),
    additionalPrincipal: z.number(),
    interest: z.number(),
    escrow: z.number(),
    fee: z.number(),
    advance: z.number(),
    advancePrincipal: z.number(),
    advanceInterest: z.number(),
    suspense: z.number(),
    unappliedSuspense: z.number(),
    holdback: z.number(),
    reserve: z.number(),
    deferredPrincipal: z.number(),
    deferredInterest: z.number(),
    deferredFee: z.number(),
    expectedPayment: z.number(),

    sameDayAch: z.boolean(),

    // TODO: processedAt is mixed — some payment types store a plain date (UTC midnight), others store a true instant
    processedAt: zodTemporalInstant.optional(),
    failedAt: zodTemporalInstant.optional(),
    dueDate: zodTemporalPlainDate.optional(),
    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,

    referenceId: z.string().optional(),
    failureCode: z.string().optional(),
    achBatch: z.string().optional(),
    disbursementRecipient: z.string().optional(),
    comment: z.string().optional(),
  })
  .meta({ title: 'Transaction' });

export type ExportableTransaction = z.infer<typeof ExportableTransaction>;
